import React from "react";
import { PlacesList } from "../../components";

function PlacesPage() {
  return <PlacesList />;
}
export default PlacesPage;
